import { View } from 'components';
import { Draggable } from 'react-beautiful-dnd';

/**
 * DndTarget
 *
 * @return {JSX.Element}
 */
const DndTarget = ({ className, children, index, id, disabled }) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={disabled}>
      {(provided) => (
        <View
          className={className}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {children}
        </View>
      )}
    </Draggable>
  );
};

DndTarget.displayName = 'DndTarget';

export default DndTarget;
